import { Fragment, useEffect, useState, useCallback, useMemo } from 'react';
import TreatmentActivityList from './list/TreatmentActivityList/TreatmentActivityList';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setIsBasicFilterActive } from '../redux/slices/filterSlice';
import { setIsCustomFilterActive } from '../redux/slices/filterSlice';
import { Backdrop, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ColorConstants from '../defaults/ColorConstants';
import ProjectList from './list/ProjectList/ProjectList';
import FieldNames from '../defaults/FieldNames.json';

export default function Discovery({
    setIsCreatingPlannedFeature,
    setIsCreatingActualFeature,
    setIsTreatment,
    isTreatment,
    listOpen,
    setListOpen,
    setIsEditingTreatment,
    selectedFeatures,
    setSelectedFeatures,
    setMode,
    setPlannedFeature,
    isCreatingActualFeature,
    isCreatingPlannedFeature,
    userInfo,
    userRoleInfo,
    headerheight,
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [associateOpen, setAssociateOpen] = useState(false);
    const isCustomFilterActive = useSelector((state) => state.filter.isCustomFilterActive);
    const isViewingProjects = useSelector((state) => state.menu.viewingProjects);
    const config = useSelector((state) => state.configuration.config);
    const showListCardLoader = useSelector((state) => state.globalContext.showListCardLoader);

    const useStyles = makeStyles({
        listCardParent: {
            position: 'relative',
            zIndex: 0,
        },
        listCardBackdrop: {
            position: 'absolute',
        },
    });

    const listCardClasses = useStyles();

    const dispatchIsBasicFilterActive = useCallback(
        (args) => {
            dispatch(setIsBasicFilterActive(args));
        },
        [dispatch]
    );

    const dispatchIsCustomFilterActive = useCallback(
        (args) => {
            dispatch(setIsCustomFilterActive(args));
        },
        [dispatch]
    );

    useEffect(() => {
        dispatchIsBasicFilterActive(isCustomFilterActive ? false : true);
        dispatchIsCustomFilterActive(isCustomFilterActive ? true : false);
    }, [dispatchIsBasicFilterActive, dispatchIsCustomFilterActive]);

    const handleTreatmentSelected = (objectId, isPostFire, isActual) => {
        const entityStringValue = isPostFire ? 'pf' : 'f';
        navigate(`/${entityStringValue}/treatments/${objectId}`, { isActual: isActual });
    };

    const handleActivitySelected = (objectId, isPostFire, isActual) => {
        const entityStringValue = isPostFire ? 'pf' : 'f';
        navigate(`/${entityStringValue}/activities/${objectId}`, { isActual: isActual });
    };

    return (
        <Fragment>
            {/* Temporarily removing while the filter list contains no content*/}
            {/*<FilterList*/}
            {/*  headerheight={headerheight}*/}
            {/*/>*/}
            <div className={listCardClasses.listCardParent}>
                <Backdrop
                    className={listCardClasses.listCardBackdrop}
                    sx={{ color: ColorConstants.WhiteAlien, zIndex: '1250!important' }}
                    open={showListCardLoader}
                >
                    <CircularProgress color='inherit' />
                </Backdrop>
                {isViewingProjects ? (
                    <ProjectList
                        listOpen={listOpen}
                        setListOpen={setListOpen}
                        userInfo={userInfo}
                        userRoleInfo={userRoleInfo}
                        headerheight={headerheight}
                    />
                ) : (
                    <TreatmentActivityList
                        onTreatmentSelected={handleTreatmentSelected}
                        onActivitySelected={handleActivitySelected}
                        isTreatment={isTreatment}
                        selectedFeatures={selectedFeatures}
                        setSelectedFeatures={setSelectedFeatures}
                        associateOpen={associateOpen}
                        setAssociateOpen={setAssociateOpen}
                        setIsTreatment={setIsTreatment}
                        setMode={setMode}
                        setIsCreatingActualFeature={setIsCreatingActualFeature}
                        setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                        setPlannedFeature={setPlannedFeature}
                        listOpen={listOpen}
                        setListOpen={setListOpen}
                        userInfo={userInfo}
                        userRoleInfo={userRoleInfo}
                        headerheight={headerheight}
                    />
                )}
            </div>
        </Fragment>
    );
}
